import { Box } from "@mui/material";

export interface MapsLogoProps {
  size?: "small" | "medium" | "large";
}

const SIZE_PRESETS = {
  small:  { fontSize: "0.78rem",  px: 0.8,  py: 0.25, borderRadius: "4px" },
  medium: { fontSize: "0.9rem",   px: 0.95, py: 0.35, borderRadius: "5px" },
  large:  { fontSize: "1.1rem",   px: 1.2,  py: 0.5,  borderRadius: "6px" },
} as const;

export function MapsLogo({ size = "medium" }: MapsLogoProps) {
  const preset = SIZE_PRESETS[size];
  return (
    <Box
      component="span"
      aria-label="Maps"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        bgcolor: "#c62828",
        color: "#fff",
        fontWeight: 700,
        letterSpacing: "0.02em",
        lineHeight: 1.2,
        userSelect: "none",
        flexShrink: 0,
        ...preset,
      }}
    >
      Maps
    </Box>
  );
}
